import apiService from './api';
import type { CSChatResponse } from '../types/api';

export const chatService = {
  async sendMessage(sessionId: string, message: string): Promise<CSChatResponse> {
    return apiService.post<CSChatResponse>('/v1/cs-chat', {
      sessionId,
      message,
    });
  },

  async clearSession(sessionId: string): Promise<{ success: boolean }> {
    return apiService.delete<{ success: boolean }>(`/v1/cs-chat/${sessionId}`);
  },
};
